// Centralised brand data
export const VERTICALS = [
  {
    id: "fasteners",
    name: "Fasteners",
    image:
      "https://images.unsplash.com/photo-1605701249987-f0bb9b505d06?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    tagline: "M1 to M-everything",
    sub: [
      "Size Range: M1–M3 | M3–M6 | M8 and above",
      "All material grades — SS, MS, Alloy, Titanium",
      "Brass Inserts & specialty fasteners",
      "Male & Female variants, all sizes",
    ],
  },
  {
    id: "rubber",
    name: "Rubber Parts",
    image:
      "https://images.unsplash.com/photo-1765220625875-3083a2b387c7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    tagline: "Compound to component",
    sub: [
      "Rubber Compounding",
      "Compression / Injection / Blow Moulding",
      "Extrusion & Vulcanisation",
      "EPDM, NBR, Silicone & specialty grades",
    ],
  },
  {
    id: "decals",
    name: "Decals & Stickers",
    image:
      "https://images.unsplash.com/photo-1723430546460-c68228027e5d?fm=jpg&q=85&w=1600&auto=format&fit=crop",
    tagline: "Industrial-grade adhesion",
    sub: [
      "Industrial-grade adhesive decals",
      "Custom stickers and product labelling",
      "Spec compliance for premium OEMs",
      "Weather, chemical, abrasion resistant",
    ],
  },
  {
    id: "electronics",
    name: "Electronics Distribution",
    image:
      "https://images.unsplash.com/photo-1569615313731-7407da4f4594?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    tagline: "Medical-grade & beyond",
    sub: [
      "RFID Cards | Display Screens (Medical Grade)",
      "PCBs | Diodes & Rectifiers",
      "Peltier Modules | Thermocooling",
      "Transformers & power electronics",
    ],
  },
  {
    id: "injection",
    name: "Injection Moulding",
    image:
      "https://images.unsplash.com/photo-1625465837903-0e4d77bcc467?fm=jpg&q=85&w=1600&auto=format&fit=crop",
    tagline: "Mould to mass-production",
    sub: [
      "Custom plastic injection moulding",
      "Tooling and mould design",
      "Production-grade moulded parts",
      "DFM consultation included",
    ],
  },
];

export const HERO_BG =
  "https://images.unsplash.com/photo-1771582546923-c38ede3be5c6?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400";

export const STATS = [
  { value: 3419, label: "SKUs Managed" },
  { value: 241, label: "Manufacturers Onboarded" },
  { value: 114, label: "IATF 16949 Certified" },
  { value: 160, label: "NABL Labs in Network" },
  { value: 614, label: "MT Spare Capacity / Month" },
  { value: 28, label: "Dedicated Warehouses" },
];

export const PARTNERS = [
  "IIT Roorkee",
  "IIM Mumbai",
  "CIPET",
  "Indo German Tool Room",
  "Coir Board, Govt. of India",
];

export const INVESTORS = [
  {
    name: "Dr. P RangaSamy",
    title: "Advisor to Govt. of India, Defence & New Technology",
  },
  {
    name: "Mr. Sidharth Jain",
    title: "MD, Adinath Forgings | Member, CII North",
  },
  {
    name: "Mr. Mohit Sharma",
    title: "MD, Super Polymer | Member, ACMA",
  },
  {
    name: "Mr. Shubham Jain",
    title: "CEO, Yathartha Yantra (YYU) | Anchor Investor",
  },
  { name: "Mr. Pardeep Kumar", title: "CMO, Singla Forging" },
  { name: "Mr. C K Sehera", title: "MD & CEO, Print Emporio" },
];
